import { app } from '../../../app';
import { Controller } from './sms-user-registration.controller';

app.component('smsUserRegistration', {
    templateUrl: require('./sms-user-registration.html'),
    controller: Controller,
});



// WEBPACK FOOTER //
// ./src/portal/states/public/sms-user-registration/sms-user-registration.component.js